export const CONFIRMATION_TOAST_EVENT = 'confirmation-toast:show';

export type ConfirmationToastDetail = {
  message: string;
};

/**
 * Returns whether a value is a valid confirmation toast event detail.
 */
export function isConfirmationToastDetail(
  detail: unknown
): detail is ConfirmationToastDetail {
  return (
    typeof detail === 'object' &&
    detail !== null &&
    typeof (detail as ConfirmationToastDetail).message === 'string' &&
    (detail as ConfirmationToastDetail).message.length > 0
  );
}

/**
 * Shows a confirmation toast with dynamic message text.
 */
export function showConfirmationToast(detail: ConfirmationToastDetail): void {
  window.dispatchEvent(new CustomEvent(CONFIRMATION_TOAST_EVENT, { detail }));
}
